// extracted by mini-css-extract-plugin
export default {"root":"TableHeadTip_root__kXSq0","left":"TableHeadTip_left__+mKfS","introduce":"TableHeadTip_introduce__z7OIl","label":"TableHeadTip_label__cqzRL"};